import { InsertChartOutlined } from "@material-ui/icons";

export function EmptyChart() {
  return <div
          style={{
            height: "370px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            color: "#9ca3af",
            fontSize: "14px",
            fontWeight: 500,
            textAlign: "center",
          }}
        >
          {/* 🔥 MUI Icon */}
          <InsertChartOutlined
            style={{
              fontSize: 40,
              marginBottom: 8,
              color: "#cbd5f5",
            }}
          />

          No data available
        </div>
}